import { React, useEffect } from "react";
import AOS from "aos";
// import footerlogo from '../../Assets/Logo.svg';
import FooterLogo from "../../Assets/logoTwo.png";
import {
  Twitter,
  Instagram,
  EnvelopeFill,
  PhoneFill,
  GeoAltFill,
} from "react-bootstrap-icons";
import { Link } from "react-router-dom";

const bgColor = {
  background: "hsla(230, 35%, 7%, 1)",
  color: "white",
};

const Iconstyle = { marginRight: "20px" };

const quickIcons = {
  listStyle: "none",
  textDecoration: "none",
  border: "none",
  fontSize: "0.78rem",
  font: "Proxima Nova",
  marginTop: "1.5rem",
  color: "#D9DBE1",
};
const noListStyle = { marginLeft: "0", paddingLeft: "0" };

const iconColor = {
  color: "rgba(220, 255, 238, 1)",
  marginRight: "0.5rem",
  fontSize: "1rem",
};

const spacing = "mb-2";

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  return (
    <div className="container-fluid" style={bgColor} id="footer">
      <div className="row pt-5 px-2  mx-auto container" data-aos="fade-up">
        <div className="col-6 col-md-4 col-lg-3 mb-5">
          <Link
            onClick={() => {
              window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
            }}
            to="/"
          >
            <img
              src={FooterLogo}
              style={{ width: "8rem" }}
              alt="Logistat Logo"
            />
          </Link>

          <div
            className="my-3"
            style={{
              color: "#D9DBE1",
              fontSize: "0.8rem",
            }}
          >
            Lorem ipsum dolor amet, consectetur adipiscing elit.
          </div>
          <div className="">
            <Instagram href="" className="text-white mr-2" style={Iconstyle} />
            <Twitter href="" className="text-white" />
          </div>
        </div>

        <div className="col-6 col-md-4 col-lg-3 mb-5">
          <div className="fs-5">Quick Links</div>
          <div>
            <ul style={quickIcons} className="p-0">
              <Link to="/" style={quickIcons}>
                <li className={spacing}>Home</li>
              </Link>
              <a style={quickIcons} href="#about">
                <li className={spacing}>About Us</li>
              </a>
              <a style={quickIcons} href="#ourProducts">
                <li className={spacing}>Our Products</li>
              </a>
              <a style={quickIcons} href="#howItWorks">
                <li className={spacing}>How It Works</li>
              </a>
              <a style={quickIcons} href="#FAQs">
                <li className={spacing}>FAQs</li>
              </a>
              <a style={quickIcons} href="#contactUs">
                <li className={spacing}>Contact Us</li>
              </a>
            </ul>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-3 mb-5">
          <div className="fs-5">Product & Services</div>
          <div>
            <ul style={quickIcons} className="p-0">
              <a style={quickIcons} href="/">
                <li className={spacing}>Delivery Service App</li>
              </a>
              <a style={quickIcons} href="/riderApp">
                <li className={spacing}>Business Support Services</li>
              </a>
              <a style={quickIcons} href="/">
                <li className={spacing}>IT Support Services</li>
              </a>
              <a style={quickIcons} href="/adminWebapp">
                <li className={spacing}>Asset Finance</li>
              </a>
            </ul>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-3 mb-5">
          <div className="fs-5">Reach Us</div>
          <div>
            <ul style={noListStyle}>
              <li style={quickIcons}>
                <EnvelopeFill style={iconColor} />
                <a style={quickIcons} href="mailto: logistat@trusoftng.com">
                  hello@logistat.africa
                </a>
              </li>
              <li style={quickIcons}>
                <PhoneFill style={iconColor} />
                <a style={quickIcons} href="tel: +2348023257316">
                  08023257316, 08068354172
                </a>
              </li>
              <li style={quickIcons}>
                <GeoAltFill style={iconColor} />
                <a style={quickIcons} href="mailto: logistat@trusoftng.com">
                  <span>
                    Logistat Express Limited, 1st floor, 161 Herbert Macaulay
                    way yaba, Lagos.
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container text-center row mx-auto align-items-center justify-content-center">
        <div className="col-12 col-md-6 text-start">
          <div className="">
            <div
              style={{ color: "#D9DBE1", fontSize: "0.8rem" }}
              className="mb-2 mb-md-0"
            >
              <span href="">© 2022 Logistat. All rights reserved</span>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="d-flex justify-content-start justify-content-md-end my-2">
            <div>
              <span
                style={{
                  color: "#D9DBE1",
                  marginRight: "1rem",
                  fontSize: "0.8rem",
                }}
              >
                Terms & Conditions
              </span>
            </div>
            <div>
              <span
                style={{
                  width: "2px",
                  height: "23px",
                  backgroundColor: "white",
                  display: "block",
                }}
              ></span>
            </div>
            <div>
              <span
                style={{
                  color: "#D9DBE1",
                  marginRight: "1rem",
                  marginLeft: "1rem",
                  fontSize: "0.8rem",
                }}
              >
                Privacy Policy
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* <button
        onClick={() => {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        }}
        style={scrollUp}
      >
        <ArrowUp color="white" size={20} />
      </button> */}
    </div>
  );
};

export default Footer;
